import { Component, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonDirective } from '../../button/button.directive';

@Component({
  selector: 'lib-apply-panel',
  templateUrl: './apply-panel.component.html',
  imports: [MatIconModule, TranslateModule, ButtonDirective],
})
export class ApplyPanelComponent {
  readonly applyDisabled = input(false);

  readonly apply = output<void>();

  readonly cancelRequested = output<void>();

  onApplyClick(): void {
    this.apply.emit();
  }

  onCancelClick(): void {
    this.cancelRequested.emit();
  }
}
